import * as React from 'react';
import { useState } from 'react';
import {
  hexToRgb,
  rgbDataURL,
  toKebabCaseWithAccentsCyrillicCJK,
} from 'corporate-utils';

import MenuItemNested from '../menu-item-nested/MenuItemNested';
import MenuItemSingle from '../menu-item-single/MenuItemSingle';
import MobileMenu from '../mobile-menu/MobileMenu';
import { getAvailableStringFromCategoryByLocale } from '../../../utils/categories';

import {
  CloseStyled,
  HamburgerMenuBodyContainer,
  HamburgerMenuContainer,
  HamburgerMenuHeader,
  LinkLogo,
  Logo,
  MenuDivider,
  ModileMenuContainerStyled,
} from './MobileMenuModalFls.style';
import { LinkSublink } from '../../../models/auto-generated-strapi-types/types/components/LinkSublink';
import { DEFAULT_IMAGE } from '../../../models/domain/const';
import ImageWithFallback from '../../image-with-fallback/ImageWithFallback';
import { getStrapiMedia } from '../../../utils/media';
import { Link as LinkType } from '../../../models/auto-generated-strapi-types/types/components/Link';
import Link from 'next/link';
import { MenuItemStyle } from '../../../models/domain/enum';
import { SelectType, TextSize } from '../../../models/enum';
import { LocalizedPath } from '../../../models/domain/type';
import cookieCutter from 'cookie-cutter';
import { useRouter } from 'next/router';
import { KeyboardArrowRight, PersonIcon } from '../../../assets';
import {
  availableInternationalization,
  notCurrentAvailableInternationalizationFls,
} from 'corporate-types';
import LinkActionSubmenuFls from '../../link-action-submenu-fls/LinkActionSubmenuFls';
import LocalizationSelectFls from '../../localization-select-fls/LocalizationSelectFls';

const MenuMobileModalFls = ({
  mainLinks,
  megamenuLinks,
  translations,
  setOpen,
  open,
  locale,
  logo,
  localizedPaths,
  reservedArea,
  isPrerenderRequest,
}: {
  logo: any;
  mainLinks: any;
  megamenuLinks: any;
  translations: any;
  setOpen: any;
  open: boolean;
  locale: string;
  localizedPaths: any;
  reservedArea: any;
  isPrerenderRequest: boolean;
}) => {
  const [openLocal, setOpenLocal] = useState(true);
  const router = useRouter();
  const { query } = router;

  const onChangeLanguage = (language: string) => {
    const path = localizedPaths?.find?.(
      (path: LocalizedPath) => path?.locale == language
    ) || {
      href: '/',
    };
    cookieCutter.set('NEXT_LOCALE', language, {
      path: '/',
    });
    if (path.href == '') path.href = '/';
    delete query?.slug;

    const queryTranslated: any = {};

    Object.keys(query).forEach((key: string) => {
      const translationFound = translations.keys.find(
        ({ keysTranslated }: { keysTranslated: string[] }) => {
          return keysTranslated.indexOf(key) !== -1;
        }
      );

      if (translationFound && translationFound.valueTranslated[language]) {
        queryTranslated[translationFound.valueTranslated[language]] =
          query[key];
      } else {
        queryTranslated[key] = query[key];
      }
    });

    router.push(
      {
        pathname: path.href,
        query: path.href != '/' ? queryTranslated : null,
      },
      {
        pathname: path.href,
        query: path.href != '/' ? queryTranslated : null,
      },
      { locale: language }
    );
  };

  const prepareCatalogues = (megamenuLinks: any): any => {
    return (
      <>
        {megamenuLinks?.map((megamenuLink: any, index: number) => {
          return (
            <MenuItemNested
              key={`menuitemnested_${index}`}
              link={{ text: megamenuLink.text, url: '' }}
              level={1}
              open={openLocal}
              border={true}
            >
              {megamenuLink.firstChild
                ?.filter?.((category: any) => category?.depth !== 0)
                ?.map((link: any, indexInternal: number) => {
                  const father = megamenuLink.firstChild.find?.(
                    (category: any) => category?.depth === 0
                  );

                  const url = `${toKebabCaseWithAccentsCyrillicCJK(
                    father &&
                      getAvailableStringFromCategoryByLocale(
                        father,
                        locale,
                        'packages/corporate-ui/src/components/mobile-menu/mobile-menu-modal/MobileMenuModal.tsx'
                      )
                  )}/${toKebabCaseWithAccentsCyrillicCJK(
                    link &&
                      getAvailableStringFromCategoryByLocale(
                        link,
                        locale,
                        'packages/corporate-ui/src/components/mobile-menu/mobile-menu-modal/MobileMenuModal.tsx'
                      )
                  )}`;

                  return (
                    <MenuItemSingle
                      level={2}
                      open={openLocal}
                      key={`menuitemsingle_${
                        indexInternal * index + (index + indexInternal)
                      }`}
                      link={{
                        id: link,
                        text:
                          link &&
                          getAvailableStringFromCategoryByLocale(
                            link,
                            locale,
                            'packages/corporate-ui/src/components/mobile-menu/mobile-menu-modal/MobileMenuModal.tsx'
                          ),
                        url,
                        subLink: [],
                      }}
                      onClick={() => {
                        setOpen(false);
                      }}
                    ></MenuItemSingle>
                  );
                })}
            </MenuItemNested>
          );
        })}
      </>
    );
  };

  const prepareMainLink = (link: LinkType): any => {
    return (
      <MenuItemNested
        link={{ text: link.text, url: link?.url || '' }}
        key={'menuitemnested_father'}
        level={1}
        onClick={() => setOpenLocal(false)}
        open={openLocal}
        useOpenLocal={false}
        styleItem={MenuItemStyle.SECONDARY}
      >
        {link?.subLink?.map((subLink: LinkSublink, index: number) => {
          return (
            <MenuItemSingle
              level={2}
              open={openLocal}
              key={`menuitemsingle_${index + index}`}
              link={{
                id: index,
                text: subLink.text,
                url: subLink.url,
                subLink: [],
              }}
              onClick={() => {
                setOpen(false);
              }}
              styleItem={MenuItemStyle.SECONDARY}
            ></MenuItemSingle>
          );
        })}
      </MenuItemNested>
    );
  };

  return (
    <HamburgerMenuContainer open={open}>
      <HamburgerMenuBodyContainer>
        <HamburgerMenuHeader>
          <Link href="/" passHref>
            <LinkLogo>
              <Logo>
                <ImageWithFallback
                  layout="fill"
                  objectFit="cover"
                  placeholder="blur"
                  blurDataURL={rgbDataURL(
                    hexToRgb('ffffff')?.[0],
                    hexToRgb('ffffff')?.[1],
                    hexToRgb('ffffff')?.[2]
                  )}
                  src={getStrapiMedia(logo?.data?.attributes?.url ?? '')}
                  alt={logo?.data?.attributes?.alternativeText}
                  fallbackSrc={DEFAULT_IMAGE}
                  isPrerenderRequest={isPrerenderRequest}
                />
              </Logo>
            </LinkLogo>
          </Link>
          <CloseStyled
            onClick={() => {
              setOpen(false);
            }}
          />
        </HamburgerMenuHeader>

        <ModileMenuContainerStyled>
          <MobileMenu>
            {[
              prepareCatalogues(megamenuLinks),
              <MenuDivider />,
              ...mainLinks?.map((link: LinkType, index: number) => {
                return link?.subLink?.length === 0 ? (
                  <MenuItemSingle
                    level={1}
                    link={link}
                    key={`menuitems_${index}`}
                    onClick={() => {
                      setOpen(false);
                    }}
                    styleItem={MenuItemStyle.SECONDARY}
                  ></MenuItemSingle>
                ) : (
                  prepareMainLink(link)
                );
              }),
            ]}
          </MobileMenu>
        </ModileMenuContainerStyled>

        <LinkActionSubmenuFls
          text={reservedArea?.text || ''}
          title={reservedArea?.text || ''}
          size={TextSize.medium}
          icon={<PersonIcon />}
          iconEnd={<KeyboardArrowRight />}
          subLinks={reservedArea?.subLink}
        />
        <LocalizationSelectFls
          onChange={(val: string | number) => onChangeLanguage(val.toString())}
          currentValue={locale}
          options={
            Object.values(availableInternationalization)
              .filter((value) => {
                return (
                  Object.values(
                    notCurrentAvailableInternationalizationFls
                  ).indexOf(value) === -1
                );
              })
              .map((internationalization: string) => {
                return {
                  label:
                    translations?.components?.shell?.header?.languages[
                      internationalization
                    ],
                  value: internationalization,
                };
              }) || []
          }
          textSize={TextSize.medium}
          type={SelectType.third}
        />
      </HamburgerMenuBodyContainer>
    </HamburgerMenuContainer>
  );
};

export default MenuMobileModalFls;

export { MenuItemSingle, MenuItemNested };
